import React, { useContext } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Fab from "@mui/material/Fab";
import { Link } from "react-router-dom";
import ContactsIcon from "@mui/icons-material/Contacts";
import { useDispatch } from "react-redux";
import Chip from "@mui/material/Chip";

const RowInProgressDoctors = (props) => {
  const dispatch = useDispatch();

  let conditions = null;
  if (props.condition == "late") {
    conditions = (
      <Chip
        label="دیر شده"
        color="error"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "forToday") {
    conditions = (
      <Chip
        label="ارسال امروز"
        color="warning"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "forTommorow") {
    conditions = (
      <Chip
        label="ارسال فردا"
        color="secondary"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "forTwoDays") {
    conditions = (
      <Chip
        label="دو روز دیگر"
        color="primary"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "forThreeDays") {
    conditions = (
      <Chip
        label="سه روز دیگر"
        color="primary"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "notLate" || props.condition == ".") {
    conditions = (
      <Chip
        label="وقت دارد"
        color="success"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }
  if (props.condition == "inQuee") {
    conditions = (
      <Chip
        label="در انتظار "
        color="info"
        size="small"
        sx={{ width: "100%", p: 1 }}
      />
    );
  }

  const clickHandler = () => {
    dispatch({
      type: "assign",
      payload: {
        prevRoute: "/clinic/orders",
        index: 0,
      },
    });
  };
  return (
    <React.Fragment>
      <TableRow hover="true">
        <TableCell align="center">
          <Link
            to={`/clinic/orders/${props.orderId}`}
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            <Fab color="secondary" size="small" onClick={clickHandler}>
              <ContactsIcon />
            </Fab>
          </Link>
        </TableCell>
        <TableCell align="center">{props.boxNumber}</TableCell>
        <TableCell align="center">{props.startDate}</TableCell>
        <TableCell align="center">{props.patientName}</TableCell>
        <TableCell align="center">{props.labName}</TableCell>
        <TableCell align="center">{props.orderType}</TableCell>
        <TableCell align="center">{props.lastEntrance}</TableCell>
        <TableCell align="center">{props.exitPrediction}</TableCell>
        <TableCell align="center">{conditions}</TableCell>
      </TableRow>
      <TableRow></TableRow>
    </React.Fragment>
  );
};
export default RowInProgressDoctors;
